import { createAction, props } from '@ngrx/store';
import { SearchCriteria } from '@shared/models/pagination.model';

import {
  ShelfBarcodeContentPagination,
  ShelfListSearchCriteria,
  ShelfSequenceList,
  ShelfSequenceSubmit
} from '../models/shelf-list.model';

export const shelfAction = {
  shelfListRequest: createAction('[Shelf] shelf list request', props<{ payload: ShelfListSearchCriteria }>()),
  shelfListResponse: createAction('[Shelf] shelf list response', props<{ response: any }>()),
  shelfSequenceListRequest: createAction('[Shelf] shelf sequence list request', props<{ payload: any }>()),
  shelfSequenceListResponse: createAction(
    '[Shelf] shelf sequence list response',
    props<{ response: ShelfSequenceList[] }>()
  ),
  shelfSequenceSubmitRequest: createAction(
    '[Shelf] shelf sequence submit request',
    props<{ payload: ShelfSequenceSubmit[] }>()
  ),
  shelfSequenceSubmitResponse: createAction('[Shelf] shelf sequence submit response', props<{ response: any }>()),
  shelfBarcodePrintListRequest: createAction(
    '[Shelf] shelf barcode print list request',
    props<{
      payload: SearchCriteria;
    }>()
  ),
  shelfBarcodePrintListResponse: createAction(
    '[Shelf] shelf barcode print list response',
    props<{ response: ShelfBarcodeContentPagination }>()
  )
};
